/** Builder V2 text/CTA alignment values persisted in section.settings. */
export type BuilderTextAlign = "left" | "center" | "right"

export const DEFAULT_CTA_ALIGN: BuilderTextAlign = "center"

/** Normalize a stored ctaAlign value; unknown/missing values use the section default. */
export function resolveCtaAlign(
  ctaAlign: string | undefined | null,
  fallback: BuilderTextAlign = DEFAULT_CTA_ALIGN
): BuilderTextAlign {
  if (ctaAlign === "left" || ctaAlign === "center" || ctaAlign === "right") {
    return ctaAlign
  }

  return fallback
}

/** Map Builder V2 ctaAlign to flexbox alignItems for full-width CTA containers. */
export function getFlexAlignItemsFromCtaAlign(
  ctaAlign: string | undefined | null,
  fallback: BuilderTextAlign = DEFAULT_CTA_ALIGN
): "flex-start" | "center" | "flex-end" {
  switch (resolveCtaAlign(ctaAlign, fallback)) {
    case "center":
      return "center"
    case "right":
      return "flex-end"
    default:
      return "flex-start"
  }
}
